import React, { Component } from 'react';

import Login from './Login';
import Header from './Header';
import Footer from './Footer';
import Keys from './Keys';
import Profile from './Profile';
import Home from './Home';
import { Route, withRouter, Redirect } from 'react-router-dom';
import axios from 'axios';
import Zello from './Zello';
import _ from 'lodash';
import { Grid } from 'semantic-ui-react';

const renderMergedProps = (component, ...rest) => {
  const finalProps = Object.assign({}, ...rest);
  return (
    React.createElement(component, finalProps)
  );
};

const PropsRoute = ({ component, ...rest }) => {
  return (
    <Route {...rest} render={routeProps => {
      return renderMergedProps(component, routeProps, rest);
    }}/>
  );
};

const PrivateRoute = ({ component: Component, isProfile, ...rest }) => {
  const isLoggedIn = Zello.IsLoggedIn;
  const hasProfile = Zello.HasProfile;

  return (
    <Route
      {...rest}
      render={props =>
        isLoggedIn && (hasProfile || isProfile) ? (
          renderMergedProps(Component, props, rest)
        ) : isLoggedIn && !hasProfile ? (
          <Redirect to={{ pathname: '/profile', state: { from: props.location } }} />
        ) : (
          <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
        )
      }
    />
  )
};

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      url: '',
      profileRequired: false
    };
  }

  componentDidMount() {
    if (Zello.IsLoggedIn) {
      this.onLoginSuccess();
    }
  }

  componentWillUpdate() {
    if (this.props.history.action === "PUSH" && this.state.url !== this.props.history.location.pathname) {
      this.setState({url:this.props.history.location.pathname});
    }
  }

  navigateTo(url, extraState) {
    if (url === this.props.history.location.pathname) {
      if (_.size(extraState) > 0) {
        this.setState(extraState);
      }

      return;
    }

    this.props.history.push(url);

    let state = _.extend({url}, extraState);

    this.setState(state);
  }

  onLoginSuccess = () => {
    if (Zello.HasProfile) {
      this.navigateTo('/dashboard', { profileRequired: false });
    } else {
      this.navigateTo('/profile', { profileRequired: true });
    }
  };

  onLoginCancel = () => {
    this.navigateTo('/');
  };

  onLogout = () => {
    axios.request({
      url: '/api/auth',
      method: 'DELETE',
    })
    .then((data) => {
      Zello.logout();
      this.navigateTo('/', { profileRequired: false });
    })
    .catch((e) => {
      console.log("Failed to log out");
    });
  };

  onProfileComplete = () => {
    this.navigateTo("/dashboard", {
      profileRequired: false
    });
  };

  onAction = (action) => {
    if (action === 'login') {
      this.navigateTo('/login');
    } else if (action === 'logout') {
      this.onLogout();
    } else if (action === 'keys') {
      this.navigateTo('/keys');
    } else if (action === 'profile') {
      this.navigateTo('/profile');
    }
  };

  render() {
    return (
      <div className="App">
        <Header isLoggedIn={Zello.IsLoggedIn} onAction={this.onAction}/>
        <main>
          <Grid padded>
            <Grid.Column>
              <Route exact path="/" component={Home}/>
              <PropsRoute path="/login" component={Login} onSuccess={this.onLoginSuccess} onCancel={this.onLoginCancel}/>
              <PrivateRoute path="/keys" component={Keys}/>
              <PrivateRoute path="/dashboard" component={Home}/>
              <PrivateRoute path="/profile" isProfile={true} component={Profile} onComplete={this.onProfileComplete} required={this.state.profileRequired} profile={Zello.Profile}/>
            </Grid.Column>
          </Grid>
        </main>
        <Footer/>
      </div>
    );
  }
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/App.js